import { z } from 'zod';

const baseDerivativeSchema = z.object({
  underlying_asset: z.string().min(1, 'Underlying asset is required'),
  expiration_date: z.string().refine(
    (date) => new Date(date) > new Date(),
    'Expiration date must be in the future'
  ),
  exchange: z.string().min(1, 'Exchange is required'),
  currency: z.string().length(3, 'Currency must be 3 characters'),
  notes: z.string().optional(),
});

export const optionFormSchema = baseDerivativeSchema.extend({
  derivative_type: z.literal('option'),
  option_type: z.enum(['call', 'put'], {
    errorMap: () => ({ message: 'Option type must be either call or put' }),
  }),
  strike_price: z.number().positive('Strike price must be positive'),
  premium_paid: z.number().nonnegative('Premium cannot be negative'),
  contract_size: z.number().positive('Contract size must be positive'),
});

export const futureFormSchema = baseDerivativeSchema.extend({
  derivative_type: z.literal('future'),
  contract_size: z.number().positive('Contract size must be positive'),
  contract_price: z.number().positive('Contract price must be positive'),
  margin_requirement: z.number().nonnegative('Margin cannot be negative'),
});

export const derivativeFormSchema = z.discriminatedUnion('derivative_type', [
  optionFormSchema,
  futureFormSchema,
]);

export type OptionFormData = z.infer<typeof optionFormSchema>;
export type FutureFormData = z.infer<typeof futureFormSchema>;
export type DerivativeFormData = z.infer<typeof derivativeFormSchema>;
